module.exports = __webpack_public_path__ + "static/media/4S.5156259e.png";